import Modal from '@medflex/components/stories/Modal';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import QRCode from '@medflex/components/stories/QRCode';
import saveToClipboard from '@medflex/utils/saveToClipboard';
import * as PropTypes from 'prop-types';
import { IconCopy } from '@medflex/components/stories/Icons';
import { trackEvent } from '@medflex/utils/Tracking';
import Button from '@medflex/components/stories/Button';
import { showSuccessToast } from '@medflex/components/stories/Toast';
import useUserProfile from '../../hooks/useUserProfile';
import useModal from '../../hooks/useModal';

const PermanentQRCode = ({ onClose, canReset }) => {
  const { open } = useModal();
  const { userProfile } = useUserProfile();
  const qrCodeRef = useRef();
  const { t } = useTranslation('components');
  const permanentLink = userProfile.attributes.permanentInvitationPatientLink;

  const handleNewQRCodeLinkClick = () =>
    open({ modal: 'newPermanentLink', type: 'patient', returnToModal: 'patientPermanentQRCode' });

  const handleQRCodePrintClick = () => open({ modal: 'patientPermanentQRCode', action: 'print' });

  const handleQRCodeCopy = event => {
    trackEvent(event, {
      zone: 'InvitePatientModalModule',
      elementType: 'form',
      actionText: 'qr code in Zwischenablage kopieren',
    });
    saveToClipboard(qrCodeRef.current);
    showSuccessToast(t('PermanentLink.qrCode.copy_successful'), null, {
      toastId: 'qrCodeCopySuccess',
    });
  };

  return (
    <Modal
      showCloseButton
      onClickCloseButton={onClose}
      title={t('PermanentLink.qrCode.title')}
      infoUrl="https://medflex.de/hilfe/behandler-kontakte/patienten-einladen/"
    >
      <div data-component="PatientPermanentQRCode">
        <div className="flex flex-col">
          <div className="text-slate-500 mb-8">{t('PermanentLink.qrCode.info')}</div>
          {canReset && (
            <Button
              kind="link"
              className="self-end underline mb-5"
              onClick={handleNewQRCodeLinkClick}
            >
              {t('PermanentLink.qrCode.create_new_link')}
            </Button>
          )}

          <div className="flex flex-col border mb-8">
            <QRCode
              ref={qrCodeRef}
              value={permanentLink}
              className="bg-slate-50 flex flex-col items-center py-10 mb-5"
              width={256}
              margin={0}
              color={{ light: '#0000' }}
            />
            <Button kind="link" onClick={handleQRCodeCopy} className="mb-5 self-center">
              <IconCopy size="5" />
              <span className="ml-2">{t('PermanentLink.qrCode.copy_link')}</span>
            </Button>
          </div>
          <Button className="self-end hidden lg:block" onClick={handleQRCodePrintClick}>
            {t('PermanentLink.qrCode.print_practice_banner_link')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

PermanentQRCode.propTypes = {
  onClose: PropTypes.func,
  canReset: PropTypes.bool,
};

PermanentQRCode.defaultProps = {
  onClose: () => {},
  canReset: false,
};

export default PermanentQRCode;
